export const LOCATION_CHANGED: 'navigation/LOCATION_CHANGED' =
  'navigation/LOCATION_CHANGED'
